import React from "react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import "../singapore.css";
import VisaForm from "./VisaAssistanceForm";

const VisaInfo = () => {
  return (
    <section id="visa" className="visa-section">
      <div className="visa-container">
        <div className="visa-header">
          <h2 className="visa-title">Visa Requirements</h2>
          <p className="visa-subtitle">
            Important visa information for Indian citizens sailing from Singapore.
          </p>
        </div>

        <div className="visa-grid">
          <Card className="visa-card  visa-singapore">
            <div className="visa-overlay">
            <CardContent className="visa-card-content">
              {/* <div className="visa-icon-wrapper teal">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9,22 9,12 15,12 15,22"/>
                </svg>
              </div> */}
              <h3 className="visa-country">Singapore</h3>
              <p className="visa-text">
                For Singapore cruises, Indian citizens require a <strong>Singapore multi-entry visa</strong> for smooth travel and re-entry.
              </p>
            
            </CardContent>
              </div>
          </Card>

          <Card className="visa-card visa-malaysia">
            <div className="visa-overlay">

            <CardContent className="visa-card-content">
              {/* <div className="visa-icon-wrapper green">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20,6 9,17 4,12"/>
                </svg>
              </div> */}
              <h3 className="visa-country">Malaysia</h3>
              <p className="visa-text">
                <strong>Malaysia visa is exempt</strong> 
              </p>
            </CardContent>
            </div>
          </Card>

          <Card className="visa-card visa-thailand">
            <div className="visa-overlay">

            <CardContent className="visa-card-content">
              {/* <div className="visa-icon-wrapper orange">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                  <circle cx="12" cy="5" r="2"/>
                  <path d="m3 11 9-9 9 9"/>
                </svg>
              </div> */}
              <h3 className="visa-country">Thailand</h3>
              <p className="visa-text">
                Indian citizens do not need a visa to visit Thailand. Still, as of May 1, 2025, the
Thailand Digital Arrival Card (TDAC) is mandatory for all Indian travellers entering Thailand and must
be completed online before arrival.​
              </p>
            </CardContent>
            </div>
          </Card>
        </div>

        <div className="visa-footer">
          <h3 className="footer-title">Need Assistance with Your Visa?</h3>
          <p className="footer-text">
            Our travel experts can guide you through the visa application process for your cruise itinerary and help with TDAC completion.
          </p>
          <div className="footer-buttons">
            
         
<Button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
 Get Visa Assistance
</Button>


<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <VisaForm/>
      </div>
      {/* <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Understood</button>
      </div> */}
    </div>
  </div>
</div>
            {/* <Button variant="outline" className="btn-secondary">Download TDAC Guide</Button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisaInfo;
